module.exports = __webpack_public_path__ + "static/media/13.4dcbf111.jpg";